import { dlTrackEvent } from 'components/dataLayer/dataLayer'
import textServices from 'services/text-services'
import { F1GalleryPhoto, photoDisplayName } from '../gallery'
import StarIcon from './StarIcon'

interface PhotoCardProps {
  photo: F1GalleryPhoto
  onOpen: (photo: F1GalleryPhoto) => void
}

// Gallery card (Figma 5417:10250): square photo with the bottom overlay
// carrying code, author name and the vote count.
const PhotoCard = ({ photo, onOpen }: PhotoCardProps) => {
  const handleOpen = () => {
    dlTrackEvent('user_interaction', {
      action: 'select',
      element: `galeria :: foto :: ${photo.code}`,
      section: 'pitstops'
    })
    onOpen(photo)
  }

  return (
    <button type="button" className="pitstops__gallery-card" onClick={handleOpen}>
      <img
        className="pitstops__gallery-card-photo"
        src={photo.imageUrl}
        alt={photoDisplayName(photo) || `Foto ID ${photo.code}`}
        loading="lazy"
      />
      <span className="pitstops__gallery-card-overlay">
        <span className="pitstops__gallery-card-code">ID° {photo.code}</span>
        {photoDisplayName(photo) && (
          <span className="pitstops__gallery-card-name">{photoDisplayName(photo)}</span>
        )}
        <span className="pitstops__gallery-card-votes-label">
          {textServices.findByText('pitstops/gallery/votesLabel', 'Votos')}
        </span>
        <span className="pitstops__gallery-card-votes">
          <StarIcon className="pitstops__gallery-card-star" /> {photo.votes}
        </span>
      </span>
    </button>
  )
}

export default PhotoCard
